module.exports = __webpack_public_path__ + "static/media/Animation - 1720414810921.3fd33558.gif";